import { sendGenericEmail } from "../../api";
import { parsePreference } from "../../utils";

export const getCoissancePageTabs = ({preferences, accessibleOnly = false}) => {
  return [
    {
      id: "CLIENTS_IN",
      label: "Clients Entrants",
      subTitle: "clientsEntrants",
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessIN,
    },
    {
      id: "CLIENTS_TO_MONITOR",
      label: "Clients à suivre",
      subTitle: "clientsToMonitor",
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessRisky,
    },
    {
      id: "LEAVING_CLIENTS",
      label: "Clients en partance",
      subTitle: "leavingClients",
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessRisky,
    },
    {
      id: "CLIENTS_OUT",
      label: "Clients Sortants",
      subTitle: "clientsSortants",
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessOUT,
    },
    // {
    //   id: "REVIEW",
    //   label: "Review",
    //   subTitle: "review",
    //   hasAccess: parsePreference(preferences.financial).croissance.allowAccessReview,
    // },
  ].filter(tab => accessibleOnly ? tab.hasAccess : true);
}

export const sendMailToFollowupClient = async ({
  token,
  language,
  user,
  client,
  meetingDate,
  partner,
  organization,
  clientStatus
}) => {
  const recipients = {};
  const dynamicFields = {};

  try {
    recipients[user.id ?? "470189"] = client.email ?? "";
    dynamicFields["{{CLIENT_NAME}}"] = client?.name;
    dynamicFields["{{MEETING_DATE}}"] = meetingDate;
    dynamicFields["{{PARTNER_NAME}}"] = partner?.name;
    dynamicFields["{{ORGANIZATION_NAME}}"] = organization?.name;
    dynamicFields["{{PARTNER_EMAIL}}"] = partner?.email;
    // dynamicFields["{{PARTNER_PHONE}}"] = "";
  } catch (error) {
    return null;
  }

  let type = "POWERTEAM_RISKY_CLIENT_EMAIL";

  if (clientStatus === 'RECOVERED') {
    type = "POWERTEAM_RECOVERED_CLIENT_EMAIL";
  } else if (clientStatus === 'LEAVING') {
    type = "POWERTEAM_LEAVING_CLIENT_EMAIL";
  }

  return await sendGenericEmail(
    token,
    recipients,
    type,
    language,
    dynamicFields,
    organization.id
  );
}

export const sendMailToRecoveredClient = async ({
  token,
  language,
  user,
  client,
  meetingDate,
  partner,
  organization
}) => {
  const recipients = {};
  const dynamicFields = {};

  try {
    recipients[user.id ?? "470189"] = client.email ?? "";
    dynamicFields["{{CLIENT_NAME}}"] = client.name;
    dynamicFields["{{MEETING_DATE}}"] = meetingDate;
    dynamicFields["{{PARTNER_NAME}}"] = partner.name;
    dynamicFields["{{ORGANIZATION_NAME}}"] = organization.name;
    dynamicFields["{{PARTNER_EMAIL}}"] = partner.email;
    // dynamicFields["{{PARTNER_PHONE}}"] = "";
  } catch (error) {
    return null;
  }

  return await sendGenericEmail(
    token,
    recipients,
    "POWERTEAM_RECOVERED_CLIENT_EMAIL",
    language,
    dynamicFields,
    organization.id
  );
}

export const isMailSentToClientWithStatus = (status, emailNotificationsSend) => {
  if (!status || !emailNotificationsSend) return false;

  switch (status) {
    case "RISKY": return emailNotificationsSend?.asRisky?.isSent === 1;
    case "LEAVING": return emailNotificationsSend?.asLeaving?.isSent === 1;
    case "RECOVERED": return emailNotificationsSend?.asRecovered?.isSent === 1;
    default: return false;
  }
}
